import { Api } from "./Api";
import config from "../config";

export const loginUser = async (
  username: string,
  password: string,
): Promise<string> => {
  return await Api.post(`${config.backendBaseUrl}/rest-api/auth/login/`, {
    username: username,
    password: password,
  })
    .then((response) => {
      const data = response.data as IAxiosResponseData;
      return data.token as string;
    })
    .catch(() => {
      throw new Error("Onjuist e-mailadres of wachtwoord.");
    });
};

export const logoutUser = async (): Promise<void> => {
  /**
   * Logout the user.
   */
  if (localStorage.getItem("token")) {
    await Api.post(`${config.backendBaseUrl}/rest-api/auth/logout/`, {});
  }
};
